export default "https://d1e6s5z4lzmgxx.cloudfront.net/9448f7a6-2ffc-48da-926d-72a27a448f00/images/forte-icon.svg?ef1c62d5b5ee456feeda9c3a899fd091";